import { Injectable } from 'angular-ts-decorators';

import { Observable } from 'rxjs';
import { map, startWith, filter } from 'rxjs/operators';

import { RouteStreams } from '@shared/app/scripts/services/route-streams';

/**
 * Service that moves $routeParams to stream era
 */
@Injectable('routeParamsStreams')
export class RouteParamsStreams {
  constructor(
    private $routeParams: ng.route.IRouteParamsService,
    private routeStreams: RouteStreams,
  ) {
    'ngInject';
  }

  /**
   * Returns stream that emits $routeParams everytime when the route is changed
   * @return
   * stream that emits $routeParams value
   */
  getParams(): Observable<any> {
    return this.routeStreams.changeSuccess$.pipe(
      // TODO unit tests
      filter((value) => angular.isDefined(value?.params)),
      map((value) => {
        return value.params;
      }),
      startWith(this.$routeParams),
    );
  }

  /**
   * Creates a stream that reads one flag from the route
   * @param flagName
   * routeParams should be checked for this value
   * @return
   * Emit true if value is in routeParams, false otherwise
   */
  hasFlag(flagName: string): Observable<boolean> {
    return this.getParams().pipe(
      map((value) => {
        return !!value[flagName];
      }),
    );
  }
}
